import React from 'react';
import styled from 'styled-components';

import { Link, Title } from '../components/text';
import { stylesFor } from '../styles/utilities';

const Resource = ({ name, description, linkText, linkHref, isLight }) => {
  const ResourceRoot = styled.div`
    padding: 40px 20px;
    min-height: 200px;

    ${stylesFor.mediumUp`
      padding: 80px 60px;
    `};

    ${stylesFor.xLargeUp`
      padding: 120px;
      max-width: 860px;
    `};
  `;

  const Name = styled(Title)`
    ${stylesFor.xLargeUp`
      font-size: 32px;
    `};
  `;

  const Description = styled.p`
    font-size: 14px;
    line-height: 1.5;
    color: ${props =>
      props.isLight ? props.theme.color.white : props.theme.color.gray44};

    ${stylesFor.xLargeUp`
      font-size: 18px;
    `};
  `;

  const ResourceLink = styled(Link)`
    && {
      color: ${props =>
        props.isLight
          ? props.theme.color.white
          : props.theme.color.sharePointTeal};
    }
  `;

  return (
    <ResourceRoot>
      <Name isLight={isLight}>{name}</Name>
      <Description isLight={isLight}>{description}</Description>
      <ResourceLink href={linkHref} isLight={isLight}>
        {linkText}
      </ResourceLink>
    </ResourceRoot>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;

  ${stylesFor.largeUp`
    flex-direction: row;
  `};
`;

const Fabric = styled.div`
  background: ${props => props.theme.color.communicationBlue}
    url('images/fabricBackground.svg');
  background-size: cover;
  flex-grow: 1;
  display: flex;

  ${stylesFor.largeUp`
    justify-content: flex-end;
  `};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const SharePoint = styled.div`
  background-color: ${props => props.theme.color.gray96};
`;

const GitHub = styled.div`
  background-color: ${props => props.theme.color.gray19};
  background-image: url('images/octocat.svg');
  background-repeat: no-repeat;

  background-position: calc(100% - 20px) bottom;
  background-size: 76px 76px;

  ${stylesFor.xLargeUp`
    background-position: calc(100% - 32px) bottom;
    background-size: 152px 152px;
  `};
`;

export default () => {
  return (
    <Root>
      <Fabric>
        <Resource
          isLight
          name="Fluent UI"
          description="The official front-end framework for building experiences that fit seamlessly into Office and Microsoft 365. SharePoint experiences are designed and built with Fluent UI."
          linkText="Learn more"
          linkHref="https://developer.microsoft.com/en-us/fluentui"
        />
      </Fabric>
      <Wrapper>
        <SharePoint>
          <Resource
            name="SharePoint Framework (SPFx)"
            description="With the SharePoint Framework, you can use modern web technologies and tools in your preferred development environment to build web parts and apps that are responsive and mobile-ready from day one."
            linkText="Learn more"
            linkHref="https://docs.microsoft.com/en-us/sharepoint/dev/spfx/sharepoint-framework-overview"
          />
        </SharePoint>
        <GitHub>
          <Resource
            isLight
            name="SharePoint on GitHub"
            description="Join our community of passionate builders."
            linkText="View projects"
            linkHref="https://github.com/sharepoint"
          />
        </GitHub>
      </Wrapper>
    </Root>
  );
};



// WEBPACK FOOTER //
// ./src/sections/resources.js